import IDataRoom from "./IDataRoom";

export default interface IInvitations {
  email: string;
  fullName?: string;
  organization?: string;
  position?: string;
  phone?: string
}

export enum InviteStatusEnum {
  PENDING = 0,
  APPROVED = 1,
  DECLINED = 2,
  EXPIRED = 3,
  LOADING = 4,
}

export interface IPendingInviteUsers {
  created_at: string;
  email: string;
  group_name: string;
  group_id: string;
  id: string;
  invite_status: InviteStatusEnum;
  room_id: string;
  room: IDataRoom;
  type?: string;
  is_expired?: boolean;
  user_id: string;
  parent_invite_id?: string | null;
  is_parent_invite?: boolean;
  max_invites?: number | null;
  invite_name?: string;
  invite_link?: string;
}

export interface IRoomInite {
  id: string;
  email: string;
  invite_status: number,
  group_id: string;
  group_name: null | string;
  room_id: string;
  created_at: string;
  room: IDataRoom;
  is_expired?: boolean;
}

export type CreateInviteLinkPayload = {
  type: 'common';
  room_id: string;
  group_id: string;
  invite_name: string;
  ttl_invite?: number | null;
  invites_amount?: number | null;
};

export type CreateInviteLinkResponse = {
  link: string;
};

export type AcceptParentInvitePayload = {
  parent_invite_id: string;
  email: string;
};
